import {Component}                       from '@angular/core';
import {MedsConfIntf, MedsRecordLogIntf} from '@djsharkk/logr-types';
import {MenuCrudPanelContentBase}        from '../../menu-crud-panel-content-base';
import {MenuCrudPanelBotComponent}       from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-meds-bot',
			   imports    : [
				   MenuCrudPanelBotComponent
			   ],
			   templateUrl: './menu-crud-panel-meds-bot.component.html',
			   styleUrl   : './menu-crud-panel-meds-bot.component.css'
		   })
export class MenuCrudPanelMedsBotComponent extends MenuCrudPanelContentBase<MedsRecordLogIntf, MedsConfIntf> {


	constructor() {
		super('meds', false);
	}
}
